module.exports = __webpack_public_path__ + "img/basket.87829c79.png";